import { Bell, Check, RefreshCw } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';

interface NotificationHeaderProps {
  unreadCount: number;
  loading: boolean;
  onRefresh: () => void;
  onMarkAllAsRead: () => void;
}

export function NotificationHeader({
  unreadCount,
  loading,
  onRefresh,
  onMarkAllAsRead,
}: NotificationHeaderProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
      <div>
        <h1 className="text-3xl font-bold flex items-center gap-2">
          <Bell className="h-8 w-8" />
          Notifications
        </h1>
        <p className="text-muted-foreground mt-1">Manage and view all your notifications</p>
      </div>
      <div className="flex items-center gap-2">
        {unreadCount > 0 && (
          <Badge variant="destructive" className="text-sm px-3 py-1">
            {unreadCount} unread
          </Badge>
        )}
        <Button onClick={onRefresh} variant="outline" size="sm" disabled={loading}>
          <RefreshCw className={`h-4 w-4 mr-2 ${loading ? 'animate-spin' : ''}`} />
          Refresh
        </Button>
        <Button
          onClick={onMarkAllAsRead}
          variant="outline"
          size="sm"
          disabled={unreadCount === 0 || loading}
        >
          <Check className="h-4 w-4 mr-2" />
          Mark all as read
        </Button>
      </div>
    </div>
  );
}
